// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__Qvwa8","container":"PageHeader_container__qZoR8","heading":"PageHeader_heading__mHDkt"};